// extracted by mini-css-extract-plugin
export default {"noteItemContainer":"ActiveMedication_noteItemContainer__96AFO","medicationContainer":"ActiveMedication_medicationContainer__NinZD","dosage":"ActiveMedication_dosage__mCLV5"};